import isIndex from './isIndex'

export const item = (searchIn, indexOrUid) => {
  if (Array.isArray(searchIn) && typeof indexOrUid !== 'undefined') {
    if (isIndex(indexOrUid)) {
      const index = typeof indexOrUid === 'number' ? indexOrUid : parseInt(indexOrUid, 10)
      return searchIn[index]
    }
    return searchIn.find((currentItem) => currentItem._uid === indexOrUid)
  }
  return null
}

export const parsedItem = (searchIn, indexOrUid) => {
  if (Array.isArray(searchIn) && typeof indexOrUid !== 'undefined') {
    if (isIndex(indexOrUid)) {
      const index = typeof indexOrUid === 'number' ? indexOrUid : parseInt(indexOrUid, 10)
      return searchIn[index]
    }
    return searchIn.find((currentItem) => currentItem.data._uid === indexOrUid)
  }
  return null
}
